import React, { useEffect, useState } from "react";
import Utils from "../../../../../utils";
import Pagination from "react-js-pagination";
import { envelopeHistory } from "../../../../../services/CommonService";
import { ReactComponent as SleeveIcon } from "../../../../../assets/svg/sleeve-icon.svg";

const lengths = Utils.tableShowLengths();

function EnvHistory(props) {
    const [historyList, setHistoryList] = useState([]);
    const [totalHistory, setTotalHistory] = useState(0);
    const [dataParams, setDataParams] = useState({
        limit: lengths[0],
        page: 1,
    });

    useEffect(function () {
        if (props.envelopeData.id) {
            let obj = {
                id: props.envelopeData.id,
                timezone: props.envelopeData.time_zone,
                limit: dataParams.limit,
                page: dataParams.page
            };
            setHistoryList([]);
            setTotalHistory(0);

            envelopeHistory(obj)
                .then(response => {
                    setHistoryList(response.data.data);
                    setTotalHistory(parseInt(response.data.totalRecord));
                })
                .catch(err => {
                    console.error("Error fetching history:", err);
                });
        }
    }, [props.envelopeData, dataParams]);

    const handleData = (e, type) => {
        let params = { ...dataParams };
        if (type === 'pagination') {
            params.page = e;
        } else if (type === 'limit') {
            params.limit = parseInt(e.target.value);
        }
        setDataParams(params);
    };

    return (
        <div className="tab-pane fade show p-2" id="History" role="tabpanel" aria-labelledby="History-tab">
            {/* Sleeve Details Card */}
            <div className="card shadow-sm mb-4">
                <div className="card-header bg-dark-subtitle py-3">
                    <h5 className="card-title mb-0 d-flex align-items-center">
                        <SleeveIcon className="me-2" style={{ width: "24px", height: "24px" }} />
                        Sleeve Details
                    </h5>
                </div>
                <div className="card-body py-3">
                    <div className="row align-items-center flex-nowrap overflow-auto">
                        <div className="col-auto border-end px-4">
                            <div className="text-muted small">Sleeve Name</div>
                            <div className="fw-medium">{props.envelopeData.envelope_name}</div>
                        </div>
                        <div className="col-auto border-end px-4">
                            <div className="text-muted small">Time Zone</div>
                            <div className="fw-medium">{props.envelopeData.time_zone}</div>
                        </div>
                        <div className="col-auto border-end px-4">
                            <div className="text-muted small">Sleeve ID</div>
                            <div className="fw-medium">{props.envelopeData.envelope_id}</div>
                        </div>
                        <div className="col-auto border-end px-4">
                            <div className="text-muted small">Recipients</div>
                            <div className="fw-medium">{props.envelopeData.recipient_names}</div>
                        </div>
                        <div className="col-auto border-end px-4">
                            <div className="text-muted small">Date Sent</div>
                            <div className="fw-medium">{props.envelopeData.send_date}</div>
                        </div>
                        <div className="col-auto px-4">
                            <div className="text-muted small">Sender</div>
                            <div className="fw-medium">{props.envelopeData.sender_name}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* History Table Card */}
            <div className="card shadow-sm">
                <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center bg-light">
                    <h5 className="card-title mb-0">
                        <i className="bi bi-clock-history me-2"></i>
                        Activity History
                    </h5>
                    <div className="d-flex align-items-center">
                        <select 
                            className="form-select form-select-sm w-auto" 
                            value={dataParams.limit} 
                            onChange={(e) => handleData(e, 'limit')}
                        >
                            {lengths.map((item, i) => (
                                <option value={item} key={i}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th className="border-bottom">Time</th>
                                    <th className="border-bottom">User/IP</th>
                                    <th className="border-bottom">Action</th>
                                    <th className="border-bottom">Activity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historyList.length > 0 ? (
                                    historyList.map((item, index) => (
                                        <tr key={index}>
                                            <td className="py-3">{item.created_at}</td>
                                            <td className="py-3">
                                                <div className="d-flex flex-column">
                                                    <span className="fw-medium">{item.sender_name}</span>
                                                    <span className="text-muted small">IP: {item.ip_address}</span>
                                                </div>
                                            </td>
                                            <td className="py-3">
                                                <span className="badge bg-primary">{item.action}</span>
                                            </td>
                                            <td className="py-3">{item.detail}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} className="text-center py-4">
                                            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            Loading history...
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="card-footer bg-white py-3">
                    <div className="d-flex justify-content-center">
                        <Pagination
                            activePage={dataParams.page}
                            itemsCountPerPage={dataParams.limit}
                            totalItemsCount={totalHistory}
                            pageRangeDisplayed={5}
                            onChange={(e) => handleData(e, 'pagination')}
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination mb-0"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnvHistory;